import { render, staticRenderFns } from "./TemplatesListItem.vue?vue&type=template&id=06c43f20&scoped=true&"
import script from "./TemplatesListItem.vue?vue&type=script&lang=js&"
export * from "./TemplatesListItem.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesListItem.vue?vue&type=style&index=0&id=06c43f20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c43f20",
  null
  
)

export default component.exports